import _ from 'lodash';
import React, { useMemo } from 'react';
import { DisciplineFilter, ProjectRoleFilter, ProjectRoleStatusFilter } from '~/components';
import { useFeatures } from '~/hooks';

export default function ProjectRoleFiltersBar({ filters, sticky, onChange }) {
  const features = useFeatures();

  const visible = useMemo(() => {
    const isVisible = (key) => sticky?.includes(key) || !_.isEmpty(filters[key]);

    return {
      projectRoles: isVisible('projectRoles'),
      projectRoleDisciplines: features.disciplines && isVisible('projectRoleDisciplines'),
      projectRoleStatusId: isVisible('projectRoleStatusId'),
    };
  }, [filters, sticky, features]);

  return (
    <>
      {visible.projectRoles && (
        <ProjectRoleFilter
          project={filters.projects[0]}
          value={filters.projectRoles}
          onChange={({ value }) => onChange({ projectRoles: value })}
        />
      )}

      {visible.projectRoleDisciplines && (
        <DisciplineFilter
          value={filters.projectRoleDisciplines}
          placeholder="Project Role Discipline"
          onChange={({ target: { value } }) => onChange({ projectRoleDisciplines: value })}
        />
      )}

      {visible.projectRoleStatusId && (
        <ProjectRoleStatusFilter
          placeholder="Project Role Status"
          value={filters.projectRoleStatusId}
          onChange={({ value }) => onChange({ projectRoleStatusId: value })}
        />
      )}
    </>
  );
}
